import React, { useCallback, useEffect, useRef, useState } from 'react';
import ModalWrapper from 'src/components/common/modal/ModalWrapper';
import { blueButtonClass } from 'src/components/common/common';
import { usePRD2010_R01Store } from './Store_PRD2010_R01';
import { AgGridReact } from 'ag-grid-react';
import { PRD2010_R01Dto } from './Dto_PRD2010_R01';
import { useMouseContent } from 'src/utils/mouse/mouseContent';
import { showWarning } from 'src/utils/toast/toastUtil';
import { InputForm } from 'src/components/common/form/input/InputForm';
import MesTextEditor from 'src/components/common/editor/MesTextEditor';

interface Props {
    modalRef: React.RefObject<HTMLDivElement>;
}

export const Modal_PRD2010_R01 = ({ modalRef }: Props) => {
    const { 
		updatePRD2010_R01List,
		updatePRD2010_R01Instructions,
		modalVisible, setModalVisible,
		modalValueIndex, setModalValueIndex,
		modalInstructions, setModalInstructions,
	} = usePRD2010_R01Store();

	const updateInstructions = useCallback(() => {
		updatePRD2010_R01Instructions(modalValueIndex, modalInstructions);
		setModalVisible(!modalVisible);
	}, [modalValueIndex, modalInstructions, setModalVisible]);

    if (!modalVisible) return null;

    return (
        <ModalWrapper
            size={'qhmd'}
            width={1100}
            overlay={true}
            onOverlayClick={updateInstructions}
            onEscKeyDown={updateInstructions}
        >
            <div className="w-full h-[10%] flex items-center px-[24px] bg-gray-100">
                <p className="font-bold">
                    작업지시 지시사항
                </p>
            </div>
            <div className="w-full h-[75%] flex px-[24px] pt-[2px] pb-[12px] gap-[8px]" ref={modalRef}>
                <MesTextEditor 
                    value={modalInstructions} 
                    onChange={setModalInstructions} 
                    visible={modalVisible} 
                />
            </div>
            <div className="w-full h-[10%] flex items-center px-[24px] gap-[8px]">
                <button
                    className={`${blueButtonClass} flex-shrink-0 text-white font-semibold px-4  rounded shadow h-[30px]`}
                    onClick={updateInstructions}
                    disabled={false}
                >
                    확인
                </button>
            </div>
        </ModalWrapper>
    );
};
